import { render, staticRenderFns } from "./ArrowExpand.vue?vue&type=template&id=1239671e"
import script from "./ArrowExpand.vue?vue&type=script&lang=js"
export * from "./ArrowExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports